var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7959 19.5939C13.0494 19.784 13.3444 19.9112 13.6566 19.9649C13.9688 20.0186 14.2893 19.9973 14.5917 19.9029C14.8941 19.8084 15.1697 19.6434 15.3959 19.4216C15.622 19.1997 15.7922 18.9273 15.8924 18.6267C15.9925 18.3262 16.0199 18.0061 15.9721 17.6929C15.9243 17.3797 15.8028 17.0824 15.6176 16.8254C15.4323 16.5684 15.1887 16.3591 14.9067 16.2147C14.6246 16.0703 14.3124 15.9951 13.9956 15.9951H1.99927",
    stroke: "white",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4945 7.99756C17.7501 7.65675 18.0886 7.38693 18.4778 7.21374C18.867 7.04054 19.294 6.9697 19.7183 7.00796C20.1426 7.04622 20.5501 7.1923 20.902 7.43233C21.254 7.67236 21.5387 7.99837 21.7293 8.3794C21.9198 8.76044 22.0097 9.18385 21.9906 9.60943C21.9714 10.035 21.8438 10.4486 21.6199 10.811C21.3959 11.1734 21.083 11.4725 20.7109 11.68C20.3388 11.8874 19.9199 11.9963 19.4939 11.9963H1.99927",
    stroke: "white",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79687 4.39866C10.0503 4.20857 10.3453 4.08144 10.6575 4.02772C10.9697 3.97401 11.2903 3.99526 11.5926 4.08972C11.895 4.18419 12.1707 4.34915 12.3968 4.57103C12.6229 4.79291 12.7931 5.06535 12.8933 5.3659C12.9935 5.66645 13.0208 5.9865 12.973 6.29969C12.9252 6.61287 12.8037 6.91022 12.6185 7.16722C12.4332 7.42423 12.1896 7.63354 11.9076 7.7779C11.6256 7.92226 11.3133 7.99755 10.9965 7.99755H1.99927",
    stroke: "white",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoor);
export default __webpack_public_path__ + "static/media/indoor.dbe8142a72a2a407d55e5c948fa4b5d4.svg";
export { ForwardRef as ReactComponent };